// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import StepFormInputContext from "@store/Framework/Store/Context/StepFormInputContext";
import StepFormProvinceSelect from "@store/Library/Components/Bunzl/StepFormComponents/StepFormProvinceSelect";
import StepFormTextField from "@store/Library/Components/Bunzl/StepFormComponents/StepFormTextField";
import { creditFormStepStyles } from "@store/Library/Components/CreditForm/StepComponents/BasicDetailsForm";
import CardBodyComponent from "@store/Library/Widgets/Card/CardBody";
import React, { useMemo } from "react";
import { CreditFormStepProps } from "./BasicDetailsForm";

const BankingDetailsForm: React.FC<CreditFormStepProps> = ({ hasSubmitted, editable = true, stepIndex }) => {
    const stepFormInputContextData = useMemo(
        () => ({ currentStep: stepIndex, editable, hasSubmitted }),
        [stepIndex, editable, hasSubmitted],
    );
    return (
        <StepFormInputContext.Provider value={stepFormInputContextData}>
            <CardBodyComponent extendedStyles={creditFormStepStyles.cardBody}>
                <StepFormTextField
                    validation="bankName"
                    label={translate("Bank Name")}
                    placeholder={translate("Enter The Name of Your Bank")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankName"
                    disabled={!editable}
                />

                <StepFormTextField
                    validation="bankAddress"
                    label={translate("Address")}
                    placeholder={translate("Enter Your the Address of Your Bank")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankAddress"
                    disabled={!editable}
                />
                <StepFormTextField
                    validation="city"
                    label={translate("City")}
                    disabled={!editable}
                    placeholder={translate("Enter City")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankCity"
                />
                <StepFormProvinceSelect
                    validation="province"
                    label={translate("Province")}
                    hasSubmitted={hasSubmitted}
                    inputKey="province"
                    placeholder={translate("Enter Province")}
                    disabled={!editable}
                />
                <StepFormTextField
                    validation="postalCode"
                    label={translate("Postal Code")}
                    placeholder={translate("Enter Postal Code")}
                    hasSubmitted={hasSubmitted}
                    inputKey="postalCode"
                    variant="small"
                    disabled={!editable}
                />
                <StepFormTextField
                    validation="phoneNumber"
                    label={translate("Phone Number")}
                    placeholder={translate("Enter Phone Number")}
                    hasSubmitted={hasSubmitted}
                    inputKey="phoneNumber"
                    autoComplete="tel"
                    type="tel"
                    variant="small"
                    disabled={!editable}
                />
                <StepFormTextField
                    validation="name"
                    label={translate("Account Name")}
                    placeholder={translate("Enter Account Name")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankAccountName"
                    disabled={!editable}
                />
                <StepFormTextField
                    validation="accountNumber"
                    label={translate("Account Number")}
                    placeholder={translate("Enter your Account Number")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankAccountNumber"
                    disabled={!editable}
                />
                <StepFormTextField
                    label={translate("Contact Name")}
                    validation="name"
                    placeholder={translate("Enter Contact Name")}
                    hasSubmitted={hasSubmitted}
                    inputKey="bankContactName"
                    disabled={!editable}
                />
            </CardBodyComponent>
        </StepFormInputContext.Provider>
    );
};

export default BankingDetailsForm;
